import { css, styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    gap: 3px;
    align-items: center;
    font-variant-numeric: tabular-nums;
`;

export const Value = styled.div`
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
`;

export const Percent = styled.div<{ $diffDirection?: 'up' | 'down' }>`
    color: #62fa71;
    font-size: 10px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.2px;

    ${({ $diffDirection }) =>
        $diffDirection === 'down' &&
        css`
            color: #ff0000;
        `}
`;
